import { memo } from "react";
import type { TeleconsultoriaViewMode } from "../../hooks/useTeleconsultoriaViewAccess";
import { ProviderClinicView } from "./ProviderClinicView";
import { ProviderProfessionalView } from "./ProviderProfessionalView";

/**
 * Tela da PRESTADORA, por aba da página:
 * - Visão Profissional: disponibilidade e convites, próximas e minha agenda;
 * - Visão Clínica: teleconsultorias (marcadas, convites, equipe), agendas e afiliações.
 */
export const ProviderTeleconsultoriaHome = memo(function ProviderTeleconsultoriaHome({
  view,
}: {
  view: TeleconsultoriaViewMode;
}) {
  return view === "clinic" ? <ProviderClinicView /> : <ProviderProfessionalView />;
});
